var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85772 14.9003C1.61526 14.7405 1.5151 14.4291 1.61744 14.1532L3.36073 9.45526L0.661896 9.68539C0.410359 9.70683 0.171809 9.56792 0.0614815 9.33574C-0.0488472 9.10356 -0.00825024 8.8259 0.16366 8.63688L7.83763 0.199346C8.03151 -0.0138283 8.34363 -0.0618572 8.59027 0.0835314C8.8369 0.22892 8.95271 0.529213 8.86953 0.807644L7.45178 5.55309L10.3397 5.31462C10.5947 5.29356 10.8355 5.43717 10.9432 5.67449C11.0509 5.91181 11.0026 6.19262 10.8223 6.37818L2.62222 14.8156C2.41888 15.0248 2.10017 15.0601 1.85772 14.9003ZM8.7895 6.69669L6.65374 6.87305C6.45198 6.88971 6.25525 6.80312 6.12838 6.64182C6.00151 6.48051 5.96097 6.26543 6.02012 6.06746L6.92524 3.03782L2.13426 8.30552L4.22528 8.12722C4.43442 8.10939 4.63788 8.20256 4.76416 8.374C4.89043 8.54543 4.92186 8.77114 4.8474 8.97181L3.7783 11.8529L8.7895 6.69669Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.dea3ad3598ac8450797163961d96153b.svg";
export { ForwardRef as ReactComponent };